module.exports = __webpack_public_path__ + "static/media/SONIDO_ERROR.beb70c97.mp3";